import { BRAND_CONFIG } from 'constants/branding';

/**
 * How a legal page names the party it is from.
 *
 * <p>The brand name and the legal name are separate fields because usually they
 * differ — Green Giraffe trades as Green Giraffe but the entity is "Green Giraffe
 * Private Limited". For a reseller they can be the SAME string, and the obvious
 * sentence then reads "CatchMyCall is provided by CatchMyCall", or "provided by
 * CatchMyCall, operating as CatchMyCall". Both were live.
 *
 * <p>So the pages ask here instead of interpolating both names unconditionally.
 */
export const partyNamesMatch = (): boolean =>
  BRAND_CONFIG.privacy.legalName.trim().toLowerCase() ===
  BRAND_CONFIG.brandName.trim().toLowerCase();
